export default "__VITE_ASSET__BBUIznw8__"